import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import { UserAnalyticsService } from "@analytics/index";

import useEffectAfterMount from "@hooks/useEffectAfterMount";

import { usePopupActions, usePopupState } from "@store/popupStore";

import theme from "@theme/index";

import { extractTextFromJsx } from "@utilities/extractStringFromJsx";

/**
 * `Notification` component for displaying a notification dialog.
 *
 * The open state is controlled by a central store. This allows for a single notification component within the entire app
 * whose content and visibility can be set when the notification is triggered and reset on subsequent calls.
 * Displays a dialog window with a title, content, and an action button for closing the notification.
 *
 * @returns {React.ReactNode} The Notification dialog component.
 */
export default function Notification() {
  const { notification } = usePopupState();
  const PopupActions = usePopupActions();

  const { content, isOpen, redirect, title } = notification;

  const handleClose = () => {
    PopupActions.closeNotification();
  };

  return isOpen ? (
    <Dialog aria-labelledby="dialog-title" onClose={handleClose} open={isOpen}>
      {title && (
        <DialogTitle id="dialog-title" sx={{ borderBottom: `1px solid ${theme.palette.borderColor.dark}`, mb: 2 }}>
          {title}
        </DialogTitle>
      )}
      <DialogContent
        sx={{
          overflowX: "hidden",
        }}
      >
        {content}
      </DialogContent>
      <DialogActions
        sx={{
          padding: "20px 24px",
        }}
      >
        <Button color="primary" onClick={handleClose} variant="contained">
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  ) : (
    <div />
  );
}
